import axios from 'axios';

const instance = axios.create({
     baseURL:"/API/"
     //     baseURL:"https://mazaraat.org/API/"
        //  roomURL:"https://alraihaan.mazaraat.org/API/"
   // baseURL:'https://localhost:44339/'
});

export default (instance);